module.exports = __webpack_public_path__ + "static/media/cdk_white_footer.2fb24cdd.svg";